export const animateTrailEffect = (sourceEl, targetRef = null) => {
  if (!sourceEl || !targetRef.current) return;

  const source = sourceEl.getBoundingClientRect();
  const target = targetRef.current.getBoundingClientRect();

  // Clone the actual element
  const ghost = sourceEl.cloneNode(true);

  Object.assign(ghost.style, {
    position: "fixed",
    zIndex: 9999,
    left: `${source.left}px`,
    top: `${source.top}px`,
    width: `${Math.max(source.width, 80)}px`,
    padding: "6px 10px",
    borderRadius: "6px",

    fontWeight: "600",
    pointerEvents: "none",
    transition: "transform 3.2s, opacity 3.2s ease",
  });

  document.body.appendChild(ghost);

  requestAnimationFrame(() => {
    ghost.style.transform = `
      translate(
        ${target.left - source.left}px,
        ${target.top - source.top}px
      )
      scale(0.9)
    `;
    ghost.style.opacity = "0";
  });

  ghost.addEventListener("transitionend", () => ghost.remove());
};
